import { ALL_LOCALE, LOCALE } from '@stores/localeWeight';

export const LOCALE_BY_DATA = ALL_LOCALE.filter((locale) => locale !== LOCALE.EN);

export const getInitLocale = () => {
  return ALL_LOCALE.reduce(
    (prev, locale) => ({ ...prev, [locale]: '' }),
    {} as Record<LOCALE, string>,
  );
};
